import React from "react";

import { Button } from "~/components/ui/button";
import { Label } from "~/components/ui/label";
import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
} from "~/components/ui/sheet";
import { Textarea } from "~/components/ui/textarea";

interface TransportistaRejectSheetProps {
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  rejectionReason: string;
  setRejectionReason: React.Dispatch<React.SetStateAction<string>>;
  isSubmitting: boolean;
  onReject: () => Promise<void>;
}

export const TransportistaRejectSheet: React.FC<
  TransportistaRejectSheetProps
> = ({
  isOpen,
  setIsOpen,
  rejectionReason,
  setRejectionReason,
  isSubmitting,
  onReject,
}) => {
  return (
    <Sheet open={isOpen} onOpenChange={setIsOpen}>
      <SheetContent className="sm:max-w-md">
        <SheetHeader>
          <SheetTitle>Rechazar Nota de Venta</SheetTitle>
          <SheetDescription>
            Ingrese el motivo del rechazo para esta nota de venta en tránsito
          </SheetDescription>
        </SheetHeader>
        <div className="mt-6 flex flex-col gap-4">
          <div className="mt-4">
            <Label htmlFor="rejection-reason" className="text-sm font-medium">
              Motivo del rechazo
            </Label>
            <Textarea
              id="rejection-reason"
              placeholder="Ingrese el motivo del rechazo..."
              value={rejectionReason}
              onChange={(e) => setRejectionReason(e.target.value)}
              className="mt-2"
              rows={4}
            />
          </div>

          <div className="mt-4 flex justify-end gap-3">
            <Button
              variant="outline"
              onClick={() => setIsOpen(false)}
              disabled={isSubmitting}
            >
              Cancelar
            </Button>
            <Button
              onClick={onReject}
              variant="destructive"
              disabled={isSubmitting || !rejectionReason?.trim()}
            >
              {isSubmitting ? "Procesando..." : "Confirmar Rechazo"}
            </Button>
          </div>
        </div>
      </SheetContent>
    </Sheet>
  );
};
